import {useEffect,useState,useCallback} from "react";
import {getObjectRecordAudit} from '../integration/ObjectManager.js';
import {consoleLog} from '../utilities/Utilities.js';
import {useSnackbar} from './SnackbarContext.js';
import COMPONENT_MAP from './Repository/Components.js';
const list_name='audit';
const file='Audit.js';

const Audit=({parentId:entityId,entityType,application,userData,refreshToken})=>{
    const [loading,setLoading]=useState(true);
    const [records,setRecords]=useState([]);
    const {showSnackbar}=useSnackbar();

    const getRecords=useCallback((isSubscribed=true)=>{
        getObjectRecordAudit({entityType:entityType,entityId:entityId,entityParams:['_lang='+application.globalData.lang]})
        .then((data)=>{
            consoleLog({file:file,context:'getRecords - getObjectRecords',arg_name:'data',arg_value:data});
            if(!isSubscribed) return;
            if('error' in data){
                showSnackbar(data.error,'error');
            }
            else if(data.length>0){
                setRecords(data);
            }
            else{
                setRecords([]);
            }
            setLoading(false);
        });
    }, [entityId, entityType, application.globalData.lang, showSnackbar]);

    useEffect(()=>{
        let isSubscribed=true;
        if(entityId){
            getRecords(isSubscribed);
        }
        else{
            setLoading(false);
        }
        return()=>{
            isSubscribed=false;
        };
    },[entityId,getRecords,refreshToken]);

    const handleClickEvent=(args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'click_event',arg_value:args});
        switch(args?.action){
            case "refresh":
                setRecords([]);
                getRecords();
                break;
            default:
                break;
        }
    }

    const renderList=()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={records}
                focusOnSearchInput={false}
                list_name={list_name}
                loading={loading}
                file={file}
                application={application}
                initialState={null}
                entityRules={{'entityRules':'false'}}
                handleClickEvent={handleClickEvent}
                userData={userData}
                actions={{}}
            />
        ):null; 
    };

    return(renderList());
}

export default Audit;